import React, { useEffect, useState } from 'react';
import IntlMessage from '../../helpers/intlMessage';
import {
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Button,
	Card,
	Row,
	Col,
	FormGroup,
	Label,
	Input,
} from 'reactstrap';
import { httpRequest } from '@util/api-common.util';
import { useDispatch } from 'react-redux';
import * as actions from '@common/common.action';

export default function ModalInfoObito({
	intl,
	isOpen,
	setOpenModalInfoObito,
	laudoId,
}) {
	const { messages } = intl;
	const dispatch = useDispatch();
	const [dataHoraObito, setDataHoraObito] = useState('');
	const [observacoesObito, setObservacoesObito] = useState('');
	const [isUpdate, setUpdate] = useState(false);
	const [idInfo, setIdInfo] = useState(0);

	useEffect(() => {
		// Obter informações quando abrir o modal
		if (isOpen) {
			httpRequest(`Laudos/${laudoId}/obitos`, 'GET').then((res) => {
				if (res.data.id !== null) {
					setUpdate(true);
					setIdInfo(res.data.id);
					setObservacoesObito(res.data.observacao);
					setDataHoraObito(converterParaFormatoOriginal(res.data.data));
				}
			});
		}
	}, [isOpen]);

	const converterData = (data) => {
		const partes = data.split('T');
		const dataPartes = partes[0].split('-');
		const horaPartes = partes[1].split(':');
		const ano = dataPartes[0];
		const mes = dataPartes[1];
		const dia = dataPartes[2];
		const hora = horaPartes[0];
		const minuto = horaPartes[1];

		const dataFormatada = `${dia}/${mes}/${ano} ${hora}:${minuto}`;

		return dataFormatada;
	};

	const converterParaFormatoOriginal = (dataFormatada) => {
		const partes = dataFormatada.split(' ');
		const dataPartes = partes[0].split('/');
		const horaPartes = partes[1].split(':');
		const dia = dataPartes[0];
		const mes = dataPartes[1];
		const ano = dataPartes[2];
		const hora = horaPartes[0];
		const minuto = horaPartes[1];

		const dataOriginal = `${ano}-${mes}-${dia}T${hora}:${minuto}`;

		return dataOriginal;
	};

	const alterar = () => {
		// Editar informações
		let payload = {
			id: idInfo,
			dataHora: converterData(dataHoraObito),
			observacao: observacoesObito,
		};

		httpRequest(`Laudos/${laudoId}/obitos`, 'PUT', payload)
			.then(() => {
				setOpenModalInfoObito(!isOpen);
				const message = messages['messages.obito.updateSucess'];
				dispatch(actions.showAlerta('sucesso', message, 1500));
			})
			.catch(() => {
				const message = messages['messages.obito.updateError'];
				dispatch(actions.showAlerta('erro', message, 1500));
			});
	};

	const inserir = () => {
		// Adicionar informações
		let payload = {
			dataHora: converterData(dataHoraObito),
			observacao: observacoesObito,
		};

		httpRequest(`Laudos/${laudoId}/obitos`, 'POST', payload)
			.then(() => {
				setOpenModalInfoObito(!isOpen);
				const message = messages['messages.obito.insertSucess'];
				dispatch(actions.showAlerta('sucesso', message, 1500));
			})
			.catch(() => {
				const message = messages['messages.obito.insertError'];
				dispatch(actions.showAlerta('erro', message, 1500));
			});
	};

	const onSubmit = () => {
		// Verifica se vai adicionar ou editar as informações
		if (isUpdate) {
			alterar();
		} else {
			inserir();
		}
	};

	const removeInfo = () => {
		// Remover informações
		httpRequest(`Laudos/obitos/${idInfo}`, 'DELETE')
			.then(() => {
				setOpenModalInfoObito(!isOpen);
				resetValues();
				const message = messages['messages.obito.removeSucess'];
				dispatch(actions.showAlerta('sucesso', message, 1500));
			})
			.catch(() => {
				const message = messages['messages.obito.removeError'];
				dispatch(actions.showAlerta('erro', message, 1500));
			});
	};

	const resetValues = () => {
		// Resetar valores ao fechar modal
		setDataHoraObito('');
		setObservacoesObito('');
	};

	const toggle = () => {
		// Fechar modal
		resetValues();
		setOpenModalInfoObito(!isOpen);
	};

	return (
		<Modal centered isOpen={isOpen}>
			<ModalHeader toggle={() => toggle()}>
				{messages['modalobito.title']}
			</ModalHeader>
			<ModalBody>
				<Card style={{ padding: '15px' }}>
					<Row>
						<Col xl="12">
							<FormGroup>
								<Label>{messages['dateandhour.obito']}</Label>
								<Input
									type="datetime-local"
									value={dataHoraObito}
									onChange={(e) => setDataHoraObito(e.target.value)}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col xl="12">
							<FormGroup>
								<Label>{messages['observations.obito']}</Label>
								<Input
									type="textarea"
									value={observacoesObito}
									onChange={(e) => setObservacoesObito(e.target.value)}
								/>
							</FormGroup>
						</Col>
					</Row>
				</Card>
			</ModalBody>
			<ModalFooter>
				<Button
					className="button-confirm"
					color="danger"
					disabled={!isUpdate}
					style={{ marginLeft: '0px' }}
					onClick={() => removeInfo()}
				>
					<div style={{ display: 'flex' }}>
						<i
							class="mv-basico-excluir"
							style={{ paddingTop: '3px', paddingRight: '5px' }}
						/>
						<IntlMessage id="dashboards.examDetail.delete" />
					</div>
				</Button>
				<Button
					onClick={() => toggle()}
					className="button-confirm"
					style={{ marginLeft: '0%' }}
					color="secondary"
				>
					<div style={{ display: 'flex' }}>
						<i
							class="mv-basico-cancelar"
							style={{ paddingTop: '3px', paddingRight: '5px' }}
						/>
						<IntlMessage id="dashboards.examDetails.cancel" />
					</div>
				</Button>
				<Button
					className="button-confirm"
					color="primary"
					disabled={!dataHoraObito}
					onClick={() => onSubmit()}
				>
					{isUpdate ? (
						<div style={{ display: 'flex' }}>
							<i
								class="mv-basico-atualizar"
								style={{ paddingTop: '3px', paddingRight: '5px' }}
							/>
							<IntlMessage id="dashboards.examDetail.update" />
						</div>
					) : (
						<div style={{ display: 'flex' }}>
							<i
								class="mv-basico-adicionar"
								style={{ paddingTop: '3px', paddingRight: '5px' }}
							/>
							<IntlMessage id="dashboards.examDetail.adding" />
						</div>
					)}
				</Button>
			</ModalFooter>
		</Modal>
	);
}



// WEBPACK FOOTER //
// ./src/componentes/modalInformacoesObito/index.jsx